if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


document.addEventListener('DOMContentLoaded', function() {
  function matchThumbnailHeight() {
  const mainImage = document.querySelector('[id^="GalleryViewer-"]');
  const thumbnailContainer = document.querySelector('[id^="Slider-Thumbnails-"]');
    
    if (mainImage && thumbnailContainer) {
      const mainImageHeight = mainImage.offsetHeight - 20; // Subtract 20px
      thumbnailContainer.style.height = mainImageHeight + 'px';
      thumbnailContainer.style.maxHeight = mainImageHeight + 'px';
    }
  }
  
  matchThumbnailHeight();
  window.addEventListener('resize', matchThumbnailHeight);
});

// Add keyboard navigation to the existing JavaScript
document.addEventListener('DOMContentLoaded', function() {
  function addProductImageNavigation() {
    // Only add arrows on desktop (screen width > 750px)
    if (window.innerWidth <= 750) return;
    
   const mainImageContainer = document.querySelector('[id^="GalleryViewer-"]');
const thumbnailItems = document.querySelectorAll('[id^="Slider-Thumbnails-"] .thumbnail-list__item');
    
    if (!mainImageContainer || thumbnailItems.length <= 1) return;

    // Check if arrows already exist to prevent duplicates
    if (mainImageContainer.querySelector('.product-image-nav')) return;

    // Create navigation arrows
    const prevArrow = document.createElement('button');
    prevArrow.className = 'product-image-nav product-image-nav--prev';
    prevArrow.innerHTML = '<svg viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>';
    
    const nextArrow = document.createElement('button');
    nextArrow.className = 'product-image-nav product-image-nav--next';
    nextArrow.innerHTML = '<svg viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>';

    mainImageContainer.appendChild(prevArrow);
    mainImageContainer.appendChild(nextArrow);

    // Navigation functionality
    let currentIndex = 0;

   function updateActiveImage(index) {
  thumbnailItems.forEach(item => item.querySelector('button').removeAttribute('aria-current'));
  
  if (thumbnailItems[index]) {
    thumbnailItems[index].querySelector('button').setAttribute('aria-current', 'true');
    thumbnailItems[index].querySelector('button').click();
    thumbnailItems[index].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
}

    function goToPrevious() {
      currentIndex = currentIndex > 0 ? currentIndex - 1 : thumbnailItems.length - 1;
      updateActiveImage(currentIndex);
    }

    function goToNext() {
      currentIndex = currentIndex < thumbnailItems.length - 1 ? currentIndex + 1 : 0;
      updateActiveImage(currentIndex);
    }

    // Arrow click events
    prevArrow.addEventListener('click', goToPrevious);
    nextArrow.addEventListener('click', goToNext);

    // Keyboard navigation
    document.addEventListener('keydown', function(event) {
      // Only work when user is on the product page (not typing in forms)
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') return;
      
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goToPrevious();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        goToNext();
      }
    });

    // Track current active image
    thumbnailItems.forEach((item, index) => {
      item.addEventListener('click', function() {
        currentIndex = index;
      });
    });
  }

  addProductImageNavigation();
  
  // Re-check on window resize
  window.addEventListener('resize', function() {
    if (window.innerWidth <= 750) {
      // Remove arrows on mobile
      const arrows = document.querySelectorAll('.product-image-nav');
      arrows.forEach(arrow => arrow.remove());
    } else {
      // Add arrows on desktop
      addProductImageNavigation();
    }
  });
});


